export const formatText = (text: string, splitBy = "-", joinBy = " ") => {
	return text
		.toLowerCase()
		.split(splitBy)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(joinBy);
};

export const slugify = (text: string) => {
	return text
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9]/g, "-")
		.replace(/-+/g, "-")
		.replace(/^-+|-+$/g, "");
};
